var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSneakers = function SvgSneakers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 22V19.2105C1.6665 18.3641 2.19303 17.5973 2.97603 17.2895C3.70949 17.0087 4.39193 16.6038 5.01888 16.1316C5.72901 15.5967 6.3396 14.9254 6.84699 14.1805L8.6665 16L9.6665 15L7.58055 12.914C7.80805 12.4489 8.00056 11.9705 8.15735 11.4908L10.6665 14L11.6665 13L8.55012 9.88362C8.62746 9.4052 8.6665 8.93969 8.6665 8.5L10.1665 7.5L11.6665 9L14.1665 6.5L14.1665 3.5L15.6665 2L23.6665 10L19.6665 14H17.6665L16.6665 15L16.1665 17.5L11.6665 22H1.6665Z",
    fill: "#FFA057"
  })));
};
export default SvgSneakers;